import React, { useState, useEffect } from "react";
import SectionTitle from "../component/SectionTitle";
import Sidebar from "../component/Sidebar";
import LoaderSpinner from "../component/LoaderSpinner";
import ReactHtmlParser from "react-html-parser";

export default function Cms_Page(props) {
  const [pageDetail, setPageDetail] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const slug = props.match.params.slug;
    
    if (slug) {
      axios.post("api/get_page_details", { slug: slug }, { signal: controller.signal }).then((res) => {
          if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setPageDetail(res.data.data);
        } else {
          setPageDetail([]);
        }
        // setLoading(false);
      }).catch(error => {
          if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load page details:", error);
        }
      });
    }

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return ( 
    <div className="section-full  p-t120 p-b90 bg-white">
      <div className="container">
        <div className="section-content">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-8 col-md-12">
              <div className="blog-post-single-outer">
                <div className="blog-post-single bg-white">
                  <div className="wt-post-info">
                    {/* <div className="wt-post-media m-b10">
                      <img src={pageDetail.imgUrl} alt={pageDetail.page_title} />
                    </div> */}

                    <div className="wt-post-title">
                      <h3 className="post-title">{pageDetail.page_title}</h3>
                    </div>

                    <div className="wt-post-discription">
                    {ReactHtmlParser(pageDetail.description)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
